import charteredBookingService from '@/api/charteredbooking'
import { CHARTERED_BOOKING } from '../types'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    date: null,
    owners: [],
    chartereds: [],
    charteredId: null,
    charteredSiteId: null,
    charteredCustomTrip: false,
    charteredBusByTripType: [],
    selectedChartered: [],
    updateScreen: 1,
    loadedFirstTime: false,
    queryFilter: '',
    charteredBusQueryFilter: '',
    filterDate: null,
    charteredBusBookings: []
  },
  getters:{
    date: (state) => {
      return state.date
    },
    fullDate: (state) => {
      const fullDate = Vue.prototype.$moment(state.date).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullDate
    },
    charteredSiteId: (state) => {
      return state.charteredSiteId
    },
    loadedFirstTime: (state) =>{
      return state.loadedFirstTime
    },
    queryFilter: (state) => {
      return state.queryFilter
    },
    charteredBusQueryFilter: (state) => {
      return state.charteredBusQueryFilter
    },
    filterDate: (state) => {
      return state.filterDate
    },
    charteredBusBookings: (state) => {
      return state.charteredBusBookings
    }
  },
  mutations: {
    [CHARTERED_BOOKING.SET_DATE] (state, date) {
      state.date = date
    },
    [CHARTERED_BOOKING.SELECT_OWNER] (state, item) {
      state.owners.splice(0, 1)
      state.owners.push(item)
    },
    [CHARTERED_BOOKING.REMOVE_OWNER] (state, index) {
      state.owners.splice(index, 1)
    },
    [CHARTERED_BOOKING.SET_CHARTEREDS] (state, chartereds) {
      state.chartereds = chartereds
    },
    [CHARTERED_BOOKING.SET_CHARTERED_ID] (state, charteredId) {
      state.charteredId = charteredId
    },
    [CHARTERED_BOOKING.SET_SITE_ID] (state, siteId) {
      state.charteredSiteId = siteId
    },
    [CHARTERED_BOOKING.SET_CUSTOM_TRIP] (state, customTrip) {
      state.charteredCustomTrip = customTrip
    },
    [CHARTERED_BOOKING.SET_CHARTERED_BUS_BY_TRIP_TYPE] (state, charteredBusByTripType) {
      state.charteredBusByTripType = charteredBusByTripType
    },
    [CHARTERED_BOOKING.SET_SELECTED_CHARTERED](state, obj) {
      state.selectedChartered.set(obj.key, obj.id)
      state.updateScreen +=1
    },
    [CHARTERED_BOOKING.INIT_SELECTED_CHARTERED](state, selectedChartered) {
      state.selectedChartered = selectedChartered
      state.updateScreen +=1
    },
    [CHARTERED_BOOKING.CLEAR_SELECTED_CHARTERED](state) {
      state.selectedChartered.clear()
      state.updateScreen +=1
    },
    [CHARTERED_BOOKING.DELETE_SELECTED_CHARTERED](state, key) {
      state.selectedChartered.delete(key)
      state.updateScreen +=1
    },
    [CHARTERED_BOOKING.SET_LOADED_FIRST_TIME] (state, loadedFirstTime) {
      state.loadedFirstTime = loadedFirstTime
    },
    [CHARTERED_BOOKING.SET_QUERY_FILTER] (state, queryFilter) {
      state.queryFilter = queryFilter
    },
    [CHARTERED_BOOKING.SET_CHARTERED_BUS_QUERY_FILTER] (state, charteredBusQueryFilter) {
      state.charteredBusQueryFilter = charteredBusQueryFilter
    },
    [CHARTERED_BOOKING.SET_FILTER_DATE] (state, filterDate) {
      state.filterDate = filterDate
    },
    [CHARTERED_BOOKING.SET_CHARTERED_BUS_BOOKINGS] (state, charteredBusBookings) {
      state.charteredBusBookings = charteredBusBookings
    }
  },
  actions: {
    setDate ({commit}, date) {
      commit(CHARTERED_BOOKING.SET_DATE, date)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(CHARTERED_BOOKING.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(CHARTERED_BOOKING.REMOVE_OWNER, index)
    },
    setCharteredId ({commit}, charteredId) {
      commit(CHARTERED_BOOKING.SET_CHARTERED_ID, charteredId)
    },
    setCharteredSiteId ({commit}, siteId) {
      commit(CHARTERED_BOOKING.SET_SITE_ID, siteId)
    },
    setCharteredCustomTrip ({commit}, customTrip) {
      commit(CHARTERED_BOOKING.SET_CUSTOM_TRIP, customTrip)
    },
    setcharteredBusByTripType: function ({commit}, val) {
      commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_BY_TRIP_TYPE, val)
    },
    setSelectedCharted: function ({commit}, obj) {
      commit(CHARTERED_BOOKING.SET_SELECTED_CHARTERED, obj)
    },
    deleteSelectedCharted: function ({commit}, key) {
      commit(CHARTERED_BOOKING.DELETE_SELECTED_CHARTERED, key)
    },
    clearSelectedCharted: function ({commit}) {
      commit(CHARTERED_BOOKING.CLEAR_SELECTED_CHARTERED)
    },
    setLoadedFirstTime ({commit}, loadedFirstTime) {
      commit(CHARTERED_BOOKING.SET_LOADED_FIRST_TIME, loadedFirstTime)
    },
    setQueryFilter ({commit}, queryFilter) {
      commit(CHARTERED_BOOKING.SET_QUERY_FILTER, queryFilter)
    },
    setFilterDate ({commit}, filterDate) {
      commit(CHARTERED_BOOKING.SET_FILTER_DATE, filterDate)
    },
    setCharteredBusQueryFilter ({commit}, charteredBusQueryFilter) {
      commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_QUERY_FILTER, charteredBusQueryFilter)
    },
    async getChartereds ({dispatch, getters, commit, state}) {
      const userEmail = state.owners[0].email
      const date =  getters.fullDate
      try {
        commit(CHARTERED_BOOKING.INIT_SELECTED_CHARTERED, new Map())
        let response = await charteredBookingService.getChartereds(userEmail, date, state.charteredSiteId)
        commit(CHARTERED_BOOKING.SET_CHARTEREDS, response.data)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveBookingOfAnUser ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        const date =  getters.fullDate
        const charteredBusBookingTrip = state.charteredBusByTripType
        const body = {
          userEmail,
          date,
          charteredBusBookingTrip
        }
        await charteredBookingService.createBookingOfAnUser(body)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveBooking ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        const date =  getters.fullDate
        const charteredBusBookingTrip = state.charteredBusByTripType
        const body = {
          userEmail,
          date,
          charteredBusBookingTrip
        }
        await charteredBookingService.createBooking(body)
        if(state.filterDate && state.charteredBusQueryFilter){
          dispatch('CharteredBooking/getCharteredBusBookingsWithFilter', null, {root: true})
        }
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteCharteredBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await charteredBookingService.deleteBooking(payload.charteredBus.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async getCharteredBusBookingsWithFilter({dispatch, state, commit}){
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve) => {
        const date = proto.$moment(state.filterDate).utc().format()
        charteredBookingService.getCharteredBusBookingsWithFilter(state.queryFilter, state.charteredBusQueryFilter, date).then((response) => {
            commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_BOOKINGS, response.data)
            resolve()
        }).catch(() => {
            commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_BOOKINGS, [])
        }).finally(
            dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    async manageDeleteCharteredBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await charteredBookingService.manageDeleteBooking(payload.chartered.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    clearFilters: function ({commit}) {
      commit(CHARTERED_BOOKING.SET_QUERY_FILTER, null)
      commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_QUERY_FILTER, null)
      commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_BOOKINGS, [])
    },
    clearCharteredBusBookings: function ({commit}) {
      commit(CHARTERED_BOOKING.SET_CHARTERED_BUS_BOOKINGS, [])
    }
  }
}
